import { client } from '../client';

export interface PasswordlessRequestPayload {
  username: string;
  organization_id?: string;
  division_id?: string;
  practice_id?: string;
}

export interface PasswordlessRequestResponse {
  mfa_method?: string;
  email?: string;
  phone_number?: string;
}

export const passwordlessRequest = async (
  payload: PasswordlessRequestPayload,
): Promise<PasswordlessRequestResponse> => {
  const { data } = await client.post<PasswordlessRequestResponse>('/auth/passwordless/request', payload);
  return data;
};
